import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		optionxfs: [{
				label: "烟",
				value: "101020100",
				children: [{
						label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从价计算）",
						value: "101020101",
					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以下，从价计算）",
						value: "101020102",
					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从量计算）",
						value: "101020104",
					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以下，从量计算）",
						value: "101020105",
					},
					{
						label: "卷烟（商业批发，从价计算）",
						value: "101020106",
					},
					{
						label: "雪茄烟",
						value: "101020107",
					},
					{
						label: "烟丝",
						value: "101020108",
					},
					{
						label: "卷烟（商业批发，从量计算）",
						value: "101020109",
					},
					{
						label: "电子烟（生产环节，从价计征）",
						value: "101020110",
					},
					{
						label: "电子烟（批发环节，从价计征）",
						value: "101020111",
					},
				]
			},
			{
				label: "酒",
				value: "101020200",
				children: [{
						label: "粮食白酒（从价计算）",
						value: "101020201",
					},
					{
						label: "粮食白酒（从量计算）",
						value: "101020202",
					},
					{
						label: "薯类白酒（从价计算）",
						value: "101020203",
					},
					{
						label: "薯类白酒（从量计算）",
						value: "101020204",
					},
					{
						label: "黄酒",
						value: "101020205",
					},
					{
						label: "啤酒（3000元/吨以上）",
						value: "101020206",
					},
					{
						label: "啤酒（3000元/吨以下）",
						value: "101020207",
					},
					{
						label: "酒精",
						value: "101020208",
					},
					{
						label: "其他酒",
						value: "101020299",
					},

				]
			},
			{
				label: "化妆品",
				value: "101020300",
			},
			{
				label: "首饰和珠宝玉石",
				value: "101020400",
				children: [{
						label: "金银首饰（铂金首饰、钻石及钻石饰品）",
						value: "101020401",
					},
					{
						label: "其他金银首饰及珠宝玉石",
						value: "101020499",
					},
				]
			},
			{
				label: "鞭炮、焰火",
				value: "101020500",
			},
			{
				label: "成品油",
				value: "101020600",
				children: [{
						label: "含铅汽油",
						value: "101020601",
					},
					{
						label: "无铅汽油",
						value: "101020602",
					},
					{
						label: "柴油",
						value: "101020603",
					},
					{
						label: "航空煤油",
						value: "101020604",
					},
					{
						label: "石脑油",
						value: "101020605",
					},
					{
						label: "溶剂油",
						value: "101020606",
					},
					{
						label: "润滑油",
						value: "101020607",
					},
					{
						label: "燃料油",
						value: "101020608",
					},
					{
						label: "汽油",
						value: "101020609",
					},

				]
			},
			{
				label: "汽车轮胎",
				value: "101020700",
				children: [{
						label: "子午线轮胎",
						value: "101020701",
					},
					{
						label: "斜交胎",
						value: "101020702",
					},
					{
						label: "内胎",
						value: "101020703",
					},
					{
						label: "其他汽车轮胎",
						value: "101020799",
					},

				]
			},
			{
				label: "摩托车",
				value: "101020800",
				children: [{
						label: "250毫升（含）以下的摩托车",
						value: "101020801",
					},
					{
						label: "250毫升（不含）以上摩托车",
						value: "101020802",
					},
					{
						label: "250毫升摩托车",
						value: "101020803",
					},

				]
			},
			{
				label: "乘用车",
				value: "101020900",
				children: [{
						label: "1.0升（含）以下的乘用车",
						value: "101020901",
					},
					{
						label: "1.0升以上至1.5升(含)的乘用车",
						value: "101020902",
					},
					{
						label: "1.5升以上至2.0升(含)的乘用车",
						value: "101020903",
					},
					{
						label: "2.0升以上至2.5升(含)的乘用车",
						value: "101020904",
					},
					{
						label: "2.5升以上至3.0升(含)的乘用车",
						value: "101020905",
					},
					{
						label: "3.0升以上至4.0升(含)的乘用车",
						value: "101020906",
					},
					{
						label: "4.0升以上的乘用车",
						value: "101020907",
					},

				]
			},
			{
				label: "中轻型商用客车",
				value: "101021000",
			},
			{
				label: "高尔夫球及球具",
				value: "101021100",
			},
			{
				label: "高档手表",
				value: "101021200",
			},
			{
				label: "游艇",
				value: "101021300",
			},
			{
				label: "木制一次性筷子",
				value: "101021400",
			},
			{
				label: "实木地板",
				value: "101021500",
			},
			{
				label: "电池",
				value: "101021600",
				children: [{
						label: "电池（不含铅蓄电池）",
						value: "101021601",
					}, {
						label: "铅蓄电池",
						value: "101021699",
					},

				]
			},
			{
				label: "涂料",
				value: "101021700",
			},
			{
				label: "高档化妆品",
				value: "101021800",
			},
			{
				label: "超豪华小汽车",
				value: "101021900",
				children: [{
					label: "超豪华乘用车",
					value: "101021901",
				}, {
					label: "超豪华中轻型商用客车",
					value: "101021902",
				}]
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		treedata: [{
				"id": 14,
				"jiaJDkBl": null,
				"reportName": "主表",
				"shenbzq": null,
				"shuibNameCode": "xfs_0"
			},
			{
				"id": 15,
				"jiaJDkBl": null,
				"reportName": "本期准予扣除税额计算表",
				"shenbzq": null,
				"shuibNameCode": "xfs_1"
			},
			{
				"id": 16,
				"jiaJDkBl": null,
				"reportName": "本期准予扣除税额计算表(成品油)",
				"shenbzq": null,
				"shuibNameCode": "xfs_2"
			},
			{
				"id": 17,
				"jiaJDkBl": null,
				"reportName": "本期减（免）税额计算表",
				"shenbzq": null,
				"shuibNameCode": "xfs_3"
			},
			{
				"id": 18,
				"jiaJDkBl": null,
				"reportName": "本期委托加工收回情况报告表",
				"shenbzq": null,
				"shuibNameCode": "xfs_4"
			},
			{
				"id": 19,
				"jiaJDkBl": null,
				"reportName": "卷烟批发企业月份销售明细清单",
				"shenbzq": null,
				"shuibNameCode": "xfs_5"
			},
			{
				"id": 20,
				"jiaJDkBl": null,
				"reportName": "卷烟生产企业合作生产卷烟消费税情况报告表",
				"shenbzq": null,
				"shuibNameCode": "xfs_6"
			},
			{
				"id": 21,
				"jiaJDkBl": null,
				"reportName": "附加税费计算表",
				"shenbzq": null,
				"shuibNameCode": "xfs_7"
			}
		],
		formlist: [{
			prop: "type",
			label: "类型",
			type: "select",
			width: "220px",
			selectval: [{
					label: "报表 ",
					value: "1"
				},
				{
					label: "完税凭证",
					value: "2"
				},
				{
					label: "涉税资料",
					value: "3"
				}
			]

		}, {
			prop: "name",
			label: "名称",
			type: "input",
			width: "220px"

		}, {
			prop: "description",
			label: "描述",
			type: "textarea",
			width: "380px"

		}],
		searchlistzc: [{
				prop: "policyTitle",
				label: '标题',
				type: "input"
			},
			{
				prop: "policyType",
				label: '政策类型',
				type: "select",
				selectval: comMapping.$sszskzclx,
			},
			{
				prop: "isValid",
				label: '是否失效',
				type: "select",
				selectval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "2"
					}
				],
			},
		],
		formdatazc: {
			policyTitle: "",
			isValid: "1",
			policyType: "1",
			fbDanw: "",
			policyNum: "",
			xianggxz: "",
			fabTime: "",
		},
		seezcformlist: [{
				prop: "policyTitle",
				label: "标题",
				type: "input",
				istosee: true
			},
			{
				prop: "policyNum",
				label: "发文字号",
				type: "input",
				istosee: true
			},
			{
				prop: "isValid",
				label: "是否失效",
				type: "radio",
				radioval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "2"
					}
				],
				istosee: true
			},
			{
				prop: "xianggxz",
				label: "相关税种",
				type: "input",
				istosee: true
			},
			{
				prop: "policyType",
				label: "政策类型",
				type: "radio",
				istosee: true,
				radioval: comMapping.$sszskzclx,
			},
			{
				prop: "fabTime",
				label: "发文日期",
				type: "input",
				istosee: true
			},

			{
				prop: "implementTime",
				label: "施行日期",
				type: "input",
				istosee: true
			},
			{
				prop: "fbdanw",
				label: "发文机构",
				type: "input",
				istosee: true
			},
		],
		headDatazc: [{
				title: "标题",
				prop: "policyTitle",
				width: "200",
			},
			{
				title: "发文字号",
				prop: "policyNum",
				width: "200",
			},
			{
				title: "相关文档",
				prop: "policyFile",
				width: "200"
			},
			{
				title: "是否失效",
				prop: "isValid",
				width: "200",
				custom: true
			},
			{
				title: "政策类型",
				prop: "policyType",
				width: "150",
				custom: true

			},
			{
				title: "相关税种",
				prop: "xianggxz",
				width: "150"
			},
			{
				title: "发文日期",
				prop: "fabTime",
				width: "200"
			},
			{
				title: "施行日期",
				prop: "implementTime",
				width: "200"
			},
			{
				title: "发文机构",
				prop: "fbdanw",
				width: "200",
			},
		],
		data: {
			"xfs_5": [{
				"xfs_5_x_7": {
					"cellCode": "xfs_5_1_7",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572998,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_8": {
					"cellCode": "xfs_5_1_8",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572999,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"hanh": "1",
				"xfs_5_x_3": {
					"cellCode": "xfs_5_1_3",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572994,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_4": {
					"cellCode": "xfs_5_1_4",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572995,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_5": {
					"cellCode": "xfs_5_1_5",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572996,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_6": {
					"cellCode": "xfs_5_1_6",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572997,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_1": {
					"cellCode": "xfs_5_1_1",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572992,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_5_x_2": {
					"cellCode": "xfs_5_1_2",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982572993,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				}
			}],
			"head": {
				"ancsbk": null,
				"benqsfsyxwqy": null,
				"congshygc": null,
				"cwfzr": null,
				"dengjzclx": null,
				"dialsb": null,
				"dianhhm": null,
				"dljbrqz": null,
				"dljgqz": null,
				"dljgtyshxydm": null,
				"dlrlxdh": null,
				"dlrmc": null,
				"dlrsfzhm": null,
				"dlrsfzlx": null,
				"faddbr": null,
				"fdfzrqm": null,
				"guojxzhjzhy": null,
				"hjjmse": null,
				"jfrgsmc": null,
				"jiajdkbl": null,
				"jianmzcsyzt": null,
				"jinbr": null,
				"jinbrdz": null,
				"jinbrsfzh": null,
				"kaihyh": null,
				"kaihyhzh": null,
				"kszjgxzqhdm": null,
				"nsrmc": null,
				"nsrsbh": null,
				"paiwxkzbh": null,
				"qiylx": null,
				"regionalOrganizationName": null,
				"sbpm": null,
				"sbpmmc": null,
				"shenbqnd": null,
				"shenbrq": null,
				"shenfzlx": null,
				"shenfzlxbh": null,
				"shengcjydz": null,
				"shengcjyszhq": null,
				"shenghljclcs": null,
				"shengthjzgbm": null,
				"shifzzsxgmnsr": null,
				"shiyjmzcsjEnd": null,
				"shiyjmzcsjStart": null,
				"shougtx": null,
				"shuikssqq": null,
				"shuikssqz": null,
				"slr": null,
				"slrq": null,
				"slswjgz": null,
				"smr": null,
				"suoshy": null,
				"txrq": null,
				"wurwlb": null,
				"wusclcs": null,
				"xiaoxwlqy": null,
				"yujfs": "1",
				"zhucdz": null
			},
			"xfs_4": [{
					"xfs_4_x_1.2": {
						"cellCode": "xfs_4_1_1.2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572929,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1",
					"xfs_4_x_1.1": {
						"cellCode": "xfs_4_1_1.1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572928,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_8": {
						"cellCode": "xfs_4_1_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572936,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_9": {
						"cellCode": "xfs_4_1_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572937,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_6": {
						"cellCode": "xfs_4_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572934,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_7": {
						"cellCode": "xfs_4_1_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572935,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_4": {
						"cellCode": "xfs_4_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572932,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_5": {
						"cellCode": "xfs_4_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572933,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_2": {
						"cellCode": "xfs_4_1_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572930,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_3": {
						"cellCode": "xfs_4_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572931,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_12": {
						"cellCode": "xfs_4_1_12",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572940,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_11": {
						"cellCode": "xfs_4_1_11",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572939,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_10": {
						"cellCode": "xfs_4_1_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572938,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "1001",
					"xfs_4_x_6": {
						"cellCode": "xfs_4_1001_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572945,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_7": {
						"cellCode": "xfs_4_1001_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572946,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_4": {
						"cellCode": "xfs_4_1001_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572943,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_5": {
						"cellCode": "xfs_4_1001_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572944,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_2": {
						"cellCode": "xfs_4_1001_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572941,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_1.2": {
						"cellCode": "xfs_4_1001_1.2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572941,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_1.1": {
						"cellCode": "xfs_4_1001_1.1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572941,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_4_x_3": {
						"cellCode": "xfs_4_1001_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572942,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				}
			],
			"xfs_3": [{
					"hanh": "1",
					"xfs_3_x_1": {
						"cellCode": "xfs_3_1_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572912,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_3": {
						"cellCode": "xfs_3_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572915,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_4": {
						"cellCode": "xfs_3_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572916,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_5": {
						"cellCode": "xfs_3_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572917,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_6": {
						"cellCode": "xfs_3_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572918,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_7": {
						"cellCode": "xfs_3_1_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572919,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_8": {
						"cellCode": "xfs_3_1_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572920,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_2.2": {
						"cellCode": "xfs_3_1_2.2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572914,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_2.1": {
						"cellCode": "xfs_3_1_2.1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572913,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "1000",
					"xfs_3_x_2": {
						"cellCode": "xfs_3_1000_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572921,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_3": {
						"cellCode": "xfs_3_1000_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572922,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_4": {
						"cellCode": "xfs_3_1000_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572923,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_5": {
						"cellCode": "xfs_3_1000_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572924,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_6": {
						"cellCode": "xfs_3_1000_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572925,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_7": {
						"cellCode": "xfs_3_1000_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572926,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_3_x_8": {
						"cellCode": "xfs_3_1000_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572927,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				}
			],
			"xfs_2": [{
					"hanh": "1",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572870,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572871,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_1_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572868,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572869,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_8": {
						"cellCode": "xfs_2_1_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572874,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572872,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_7": {
						"cellCode": "xfs_2_1_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572873,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "2",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_2_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572877,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_2_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572878,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_2_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572875,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_2_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572876,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_8": {
						"cellCode": "xfs_2_2_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572881,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_2_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572879,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_7": {
						"cellCode": "xfs_2_2_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572880,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "3",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_3_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572884,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_3_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572885,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_3_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572882,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_3_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572883,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_8": {
						"cellCode": "xfs_2_3_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572888,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_3_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572886,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_7": {
						"cellCode": "xfs_2_3_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572887,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "4",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_4_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572891,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_4_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572892,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_4_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572889,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_4_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572890,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_4_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572893,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "5",
					"xfs_2_x_8": {
						"cellCode": "xfs_2_5_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572896,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_5_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572894,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_7": {
						"cellCode": "xfs_2_5_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572895,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "6",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_6_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572899,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_6_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572900,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_6_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572897,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_6_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572898,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_8": {
						"cellCode": "xfs_2_6_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572903,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_6": {
						"cellCode": "xfs_2_6_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572901,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_7": {
						"cellCode": "xfs_2_6_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572902,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "7",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_7_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572906,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_7_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572907,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_7_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572904,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_7_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572905,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "8",
					"xfs_2_x_4": {
						"cellCode": "xfs_2_8_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572910,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_5": {
						"cellCode": "xfs_2_8_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572911,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_2": {
						"cellCode": "xfs_2_8_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572908,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_2_x_3": {
						"cellCode": "xfs_2_8_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572909,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				}
			],
			"xfs_7": [{
					"xfs_7_x_1": {
						"cellCode": "xfs_7_1_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572952,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_2": {
						"cellCode": "xfs_7_1_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572953,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_3": {
						"cellCode": "xfs_7_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572954,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1",
					"xfs_7_x_4": {
						"cellCode": "xfs_7_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572955,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_5": {
						"cellCode": "xfs_7_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572956,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_6": {
						"cellCode": "xfs_7_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572957,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_7": {
						"cellCode": "xfs_7_1_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572958,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_8": {
						"cellCode": "xfs_7_1_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572959,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_9": {
						"cellCode": "xfs_7_1_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572960,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_10": {
						"cellCode": "xfs_7_1_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572961,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_7_x_1": {
						"cellCode": "xfs_7_2_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572962,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_2": {
						"cellCode": "xfs_7_2_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572963,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_3": {
						"cellCode": "xfs_7_2_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572964,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "2",
					"xfs_7_x_4": {
						"cellCode": "xfs_7_2_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572965,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_5": {
						"cellCode": "xfs_7_2_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572966,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_6": {
						"cellCode": "xfs_7_2_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572967,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_7": {
						"cellCode": "xfs_7_2_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572968,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_8": {
						"cellCode": "xfs_7_2_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572969,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_9": {
						"cellCode": "xfs_7_2_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572970,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_10": {
						"cellCode": "xfs_7_2_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572971,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_7_x_1": {
						"cellCode": "xfs_7_3_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572972,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_2": {
						"cellCode": "xfs_7_3_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572973,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_3": {
						"cellCode": "xfs_7_3_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572974,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "3",
					"xfs_7_x_4": {
						"cellCode": "xfs_7_3_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572975,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_5": {
						"cellCode": "xfs_7_3_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572976,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_6": {
						"cellCode": "xfs_7_3_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572977,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_7": {
						"cellCode": "xfs_7_3_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572978,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_8": {
						"cellCode": "xfs_7_3_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572979,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_9": {
						"cellCode": "xfs_7_3_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572980,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_10": {
						"cellCode": "xfs_7_3_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572981,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_7_x_1": {
						"cellCode": "xfs_7_4_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572982,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_2": {
						"cellCode": "xfs_7_4_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572983,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_3": {
						"cellCode": "xfs_7_4_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572984,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "4",
					"xfs_7_x_4": {
						"cellCode": "xfs_7_4_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572985,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_5": {
						"cellCode": "xfs_7_4_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572986,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_6": {
						"cellCode": "xfs_7_4_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572987,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_7": {
						"cellCode": "xfs_7_4_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572988,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_8": {
						"cellCode": "xfs_7_4_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572989,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_9": {
						"cellCode": "xfs_7_4_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572990,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_7_x_10": {
						"cellCode": "xfs_7_4_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572991,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				}
			],
			"xfs_6": [{
				"xfs_6_x_4": {
					"cellCode": "xfs_6_1_4",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573003,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_5": {
					"cellCode": "xfs_6_1_5",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573004,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_2": {
					"cellCode": "xfs_6_1_2",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573001,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"hanh": "1",
				"xfs_6_x_3": {
					"cellCode": "xfs_6_1_3",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573002,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_8": {
					"cellCode": "xfs_6_1_8",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573007,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_9": {
					"cellCode": "xfs_6_1_9",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573008,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_6": {
					"cellCode": "xfs_6_1_6",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573005,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_7": {
					"cellCode": "xfs_6_1_7",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573006,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_10": {
					"cellCode": "xfs_6_1_10",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573009,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				},
				"xfs_6_x_1": {
					"cellCode": "xfs_6_1_1",
					"cellLaiy": "0",
					"cellOldVal": "",
					"cellType": "0",
					"cellVal": "",
					"goujgxValue": null,
					"id": 1684223982573000,
					"map": null,
					"reportId": 1421398319054848,
					"updateDesc": ""
				}
			}],
			"xfs_1": [{
					"hanh": "1",
					"xfs_1_x_12": {
						"cellCode": "xfs_1_1_12",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572841,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_13": {
						"cellCode": "xfs_1_1_13",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572842,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_14": {
						"cellCode": "xfs_1_1_14",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572843,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_15": {
						"cellCode": "xfs_1_1_15",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572844,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_16": {
						"cellCode": "xfs_1_1_16",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572845,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_17": {
						"cellCode": "xfs_1_1_17",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572846,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_18": {
						"cellCode": "xfs_1_1_18",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572847,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_19": {
						"cellCode": "xfs_1_1_19",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572848,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_3": {
						"cellCode": "xfs_1_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572832,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_4": {
						"cellCode": "xfs_1_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572833,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_5": {
						"cellCode": "xfs_1_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572834,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_6": {
						"cellCode": "xfs_1_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572835,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_0": {
						"cellCode": "xfs_1_1_0",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572829,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_1": {
						"cellCode": "xfs_1_1_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572830,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_10": {
						"cellCode": "xfs_1_1_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572839,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_2": {
						"cellCode": "xfs_1_1_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572831,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_11": {
						"cellCode": "xfs_1_1_11",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572840,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_7": {
						"cellCode": "xfs_1_1_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572836,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_8": {
						"cellCode": "xfs_1_1_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572837,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_9": {
						"cellCode": "xfs_1_1_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572838,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"hanh": "1000",
					"xfs_1_x_12": {
						"cellCode": "xfs_1_1000_12",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572860,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_13": {
						"cellCode": "xfs_1_1000_13",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572861,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_14": {
						"cellCode": "xfs_1_1000_14",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572862,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_15": {
						"cellCode": "xfs_1_1000_15",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572863,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_16": {
						"cellCode": "xfs_1_1000_16",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572864,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_17": {
						"cellCode": "xfs_1_1000_17",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572865,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_18": {
						"cellCode": "xfs_1_1000_18",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572866,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_19": {
						"cellCode": "xfs_1_1000_19",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572867,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_3": {
						"cellCode": "xfs_1_1000_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572851,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_4": {
						"cellCode": "xfs_1_1000_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572852,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_5": {
						"cellCode": "xfs_1_1000_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572853,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_6": {
						"cellCode": "xfs_1_1000_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572854,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_1": {
						"cellCode": "xfs_1_1000_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572849,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_10": {
						"cellCode": "xfs_1_1000_10",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572858,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_2": {
						"cellCode": "xfs_1_1000_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572850,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_11": {
						"cellCode": "xfs_1_1000_11",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572859,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_7": {
						"cellCode": "xfs_1_1000_7",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572855,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_8": {
						"cellCode": "xfs_1_1000_8",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572856,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_1_x_9": {
						"cellCode": "xfs_1_1000_9",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572857,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				}
			],
			"xfs_0": [{
					"xfs_0_x_6": {
						"cellCode": "xfs_0_1_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572788,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_0.1": {
						"cellCode": "xfs_0_1_0.1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572779,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_4": {
						"cellCode": "xfs_0_1_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572784,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1",
					"xfs_0_x_5": {
						"cellCode": "xfs_0_1_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572786,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_2": {
						"cellCode": "xfs_0_1_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572782,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_3": {
						"cellCode": "xfs_0_1_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572783,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_0.2": {
						"cellCode": "xfs_0_1_0.2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572780,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572781,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_4A": {
						"cellCode": "xfs_0_1_4A",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572785,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_5B": {
						"cellCode": "xfs_0_1_5B",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572787,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_6C": {
						"cellCode": "xfs_0_1_6C",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572789,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_6": {
						"cellCode": "xfs_0_1000_6",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572797,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_4": {
						"cellCode": "xfs_0_1000_4",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572793,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1000",
					"xfs_0_x_5": {
						"cellCode": "xfs_0_1000_5",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572795,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_2": {
						"cellCode": "xfs_0_1000_2",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572791,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_3": {
						"cellCode": "xfs_0_1000_3",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572792,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1000_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572790,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_4A": {
						"cellCode": "xfs_0_1000_4A",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572794,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_5B": {
						"cellCode": "xfs_0_1000_5B",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572796,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"xfs_0_x_6C": {
						"cellCode": "xfs_0_1000_6C",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572798,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1001_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "123123",
						"goujgxValue": null,
						"id": 1684223982572800,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1001",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1001_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "2222",
						"goujgxValue": null,
						"id": 1684223982572799,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1002_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572802,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1002",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1002_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572801,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1003_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572804,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1003",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1003_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572803,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1004_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572806,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1004",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1004_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572805,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1005_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572808,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1005",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1005_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572807,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1006_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572810,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1006",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1006_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572809,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1007_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572812,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1007",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1007_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572811,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1008_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572814,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1008",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1008_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572813,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1009_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572816,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1009",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1009_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572815,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1010_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572818,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1010",
					"xfs_0_x_1": {
						"cellCode": "xfs_0_1010_1",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572817,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					}
				},
				{
					"xfs_0_x_1D": {
						"cellCode": "xfs_0_1011_1D",
						"cellLaiy": "0",
						"cellOldVal": "",
						"cellType": "0",
						"cellVal": "",
						"goujgxValue": null,
						"id": 1684223982572819,
						"map": null,
						"reportId": 1421398319054848,
						"updateDesc": ""
					},
					"hanh": "1011"
				}
			]
		}

	}
	return obj
}